import React from "react";
import { FleetrifyModal } from "../../../Modal/modal";
import { fleetrifyIcons } from "../../../../assets/icons/icons";
import { useBulkUploadBranchController } from "../../../../controllers/useBulkUploadBranchController";
import { FleetrifyButton } from "../../../Button/customButton";

import BranchPreviewModal, { BranchBulkUploadRow } from "./branchPreview Upload";


const BranchBulkUploadModal = ({
    isModalOpen,
    setIsModalOpen,
}: {
    isModalOpen: boolean;
    setIsModalOpen: (param: boolean) => void;
}) => {
    const {
        file,
        isLoading,
        isDragging,
        isFetchingTemplate,
        previewData,
        requirementModalOpen,
        previewModal,
        handleTemplateDownload,
        handleFileChange,
        onDragOver,
        onDragLeave,
        onDrop,
        handleSubmit,
        setRequirementModalOpen,
        setPreviewModal,
        setFile,
    } = useBulkUploadBranchController({ setIsModalOpen });

    const rows: BranchBulkUploadRow[] = React.useMemo(() => {
        if (!previewData || previewData.length < 2) return [];
        return previewData.slice(1).map((row: string[]) => ({
            BranchName: row[0] || "",
            ManagerName: row[1] || "",
            email: row[2] || "",
            phoneNumber: row[3] || "",
            location: row[4] || "",
            address: row[5] || "",

        }));
    }, [previewData]);

    return (
        <>
            <FleetrifyModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title="Branch Bulk Upload"
                className="max-w-2xl h-fit"
                enableOutsideClick={!requirementModalOpen && !previewModal}
            >
                <form className="px-5">
                    <div className="flex gap-3 items-center mb-6 mt-5">
                        <div className="bg-[#14388733] h-[24px] w-[24px] rounded-[3px] grid place-items-center">
                            <figure>{fleetrifyIcons.addNewUserIcon}</figure>
                        </div>
                        <h6 className="text-[14px] font-bold text-[#00032A]">
                            Upload File
                        </h6>
                    </div>

                    <p className="text-[#143887] my-6 text-sm">
                        Supports <span className="italic">CSV</span> and{" "}
                        <span className="italic">XLSX</span> formats. Maximum file size is
                        10MB.
                    </p>

                    {/* file upload Area */}
                    <label
                        htmlFor="bulk-upload"
                        className={`border-2 border-dashed border-[#14388730] transition-colors duration-300 rounded-2xl p-6 flex flex-col items-center justify-center gap-3 text-center cursor-pointer ${isDragging
                            ? "bg-[#d9e7ff]"
                            : "bg-[#F8FAFF] hover:bg-[#f0f5ff]"
                            }`}
                        onDragOver={onDragOver}
                        onDragLeave={onDragLeave}
                        onDrop={onDrop}
                    >
                        {fleetrifyIcons.uploadCloudIcon}
                        <p className="font-semibold text-[#143887]">
                            Click to upload or drag & drop your file
                        </p>

                        {file ? (
                            <div
                                className="relative inline-block"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <p className="text-[#828282] text-sm pr-6">{file.name}</p>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setFile(null);
                                    }}
                                    className="absolute right-0 top-1/2 -translate-y-1/2 bg-red-500 text-white rounded-full px-1 text-xs"
                                    title="cancel file"
                                >
                                    ×
                                </button>
                            </div>
                        ) : (
                            <p className="text-[#828282] text-sm pr-6">No file selected</p>
                        )}

                        <input
                            id="bulk-upload"
                            type="file"
                            accept=".csv,.xlsx"
                            onChange={handleFileChange}
                            className="hidden"
                        />
                    </label>

                    {/*template download button*/}
                    <p className="text-[#00032A] flex gap-1 items-center text-sm mt-6">
                        Download{" "}
                        <button
                            type="button"
                            className={`font-bold border-b border-[#00032A] italic ${isFetchingTemplate
                                ? "cursor-not-allowed text-gray-400 border-gray-400"
                                : "cursor-pointer text-[#143887]"
                                }`}
                            onClick={handleTemplateDownload}
                            disabled={isFetchingTemplate}
                        >
                            XLSX sample
                        </button>{" "}
                        template
                    </p>

                    {/* preview option */}
                    {previewData.length > 0 && file && (
                        <button
                            type="button"
                            className="font-bold border-b text-sm border-[#00032A] italic mt-3 text-[#143887]"
                            onClick={() => {
                                setPreviewModal(true);
                            }}
                        >
                            Preview Upload
                        </button>
                    )}

                    {/*footer buttons*/}
                    <div className="flex gap-3 justify-end mt-8 p-4">
                        <FleetrifyButton
                            onClick={() => {
                                setIsModalOpen(false);
                                setFile(null);
                            }}
                            className="border !py-[10px] px-[40px] bg-transparent border-[#143887] text-[#143887] hover:bg-gray-100"
                            type="button"
                        >
                            Cancel
                        </FleetrifyButton>
                        <FleetrifyButton
                            loading={isLoading}
                            disabled={!file}
                            onClick={handleSubmit}
                        >
                            Submit Upload
                        </FleetrifyButton>
                    </div>
                </form>
            </FleetrifyModal>

            {/* staff preview modal */}
            <BranchPreviewModal
                isModalOpen={previewModal}
                setIsModalOpen={(open: boolean) => {
                    if (!open) setPreviewModal(false);
                }}
                isLoading={isLoading}
                onSubmit={handleSubmit}
                disabled={!file}
                rows={rows}
            />
        </>
    );
};

export default BranchBulkUploadModal;
